// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-editpeople {
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
  }
  
  .associated-members-editpeople {
    width: 100%;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .associated-members-editpeople h2 {
    font-size: 24px; /* Larger font size for header */
    margin-bottom: 20px;
    text-align: center; /* Center-align header */
  }
  
  .associated-members-sections-editpeople {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 40px;
  }
  
  .associated-members-section-editpeople {
    flex: 0 1 auto;
    min-width: 400px;
    max-width: 650px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .data-row-editpeople {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 14px;
  }
  
  .bar-container-editpeople {
    flex-grow: 1;
    margin: 0 10px;
  }
  
  .bar-editpeople {
    height: 8px;
    background-color: #4caf50;
    border-radius: 3px;
  }
  
  .data-row-editpeople p {
    margin: 0;
  }
  
  .search-people-editpeople {
    display: flex;
    margin-bottom: 20px;
    width: 0%; /* Ensures the search bar takes full width */
    justify-content: center; /* Centers the search bar */
  }
  
  .search-people-editpeople input {
    width: 20px; /* Reduced width for the search bar */
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px 0 0 5px;
    outline: none;
    font-size: 16px;
  }
  
  .search-people-editpeople .search-btn-editpeople {
    background-color: #007bff;
    border: none;
    color: white;
    padding: 8px 12px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 0 5px 5px 0;
  }
  
  .search-people-editpeople .search-btn-editpeople:hover {
    background-color: #0056b3;
  }
  
  .people-list-editpeople {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
  }
  
  .people-card-editpeople {
    width: 220px;
    padding: 15px;
    text-align: center;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
  }
  
  .people-card-editpeople:hover {
    transform: scale(1.05);
  }
  
  .people-card-editpeople img {
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 50%;
  }
  
  .people-card-editpeople h3 {
    margin: 10px 0 5px;
  }
  
  .people-card-editpeople p {
    margin: 0;
    color: #555;
  }
  
  .people-card-editpeople button {
    background-color: #0073b1;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
    font-size: 14px;
  }
  
  .show-more-btn-editpeople {
    display: block;
    margin: 20px auto;
    padding: 8px 16px;
    background-color: #0073b1;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .page-content-editpeople {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  
  .add-btn-editpeople {
    background-color: #270388;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 14px;
    cursor: pointer;
    margin-left: 10px;
  }
  
  .add-btn-editpeople:hover {
    background-color: #270388;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/EditPeople.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe,EAAE,gCAAgC;IACjD,mBAAmB;IACnB,kBAAkB,EAAE,wBAAwB;EAC9C;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAE,4CAA4C;IACvD,uBAAuB,EAAE,2BAA2B;EACtD;;EAEA;IACE,WAAW,EAAE,qCAAqC;IAClD,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".container-editpeople {\n    width: 100%;\n    max-width: 1300px;\n    margin: 0 auto;\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n  }\n  \n  .associated-members-editpeople {\n    width: 100%;\n    margin: 20px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .associated-members-editpeople h2 {\n    font-size: 24px; /* Larger font size for header */\n    margin-bottom: 20px;\n    text-align: center; /* Center-align header */\n  }\n  \n  .associated-members-sections-editpeople {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 40px;\n  }\n  \n  .associated-members-section-editpeople {\n    flex: 0 1 auto;\n    min-width: 400px;\n    max-width: 650px;\n    padding: 20px;\n    background-color: #f5f5f5;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  .data-row-editpeople {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 10px 0;\n    font-size: 14px;\n  }\n  \n  .bar-container-editpeople {\n    flex-grow: 1;\n    margin: 0 10px;\n  }\n  \n  .bar-editpeople {\n    height: 8px;\n    background-color: #4caf50;\n    border-radius: 3px;\n  }\n  \n  .data-row-editpeople p {\n    margin: 0;\n  }\n  \n  .search-people-editpeople {\n    display: flex;\n    margin-bottom: 20px;\n    width: 0%; /* Ensures the search bar takes full width */\n    justify-content: center; /* Centers the search bar */\n  }\n  \n  .search-people-editpeople input {\n    width: 20px; /* Reduced width for the search bar */\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px 0 0 5px;\n    outline: none;\n    font-size: 16px;\n  }\n  \n  .search-people-editpeople .search-btn-editpeople {\n    background-color: #007bff;\n    border: none;\n    color: white;\n    padding: 8px 12px;\n    font-size: 16px;\n    cursor: pointer;\n    border-radius: 0 5px 5px 0;\n  }\n  \n  .search-people-editpeople .search-btn-editpeople:hover {\n    background-color: #0056b3;\n  }\n  \n  .people-list-editpeople {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 20px;\n  }\n  \n  .people-card-editpeople {\n    width: 220px;\n    padding: 15px;\n    text-align: center;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s ease;\n  }\n  \n  .people-card-editpeople:hover {\n    transform: scale(1.05);\n  }\n  \n  .people-card-editpeople img {\n    width: 100%;\n    height: 100px;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n  \n  .people-card-editpeople h3 {\n    margin: 10px 0 5px;\n  }\n  \n  .people-card-editpeople p {\n    margin: 0;\n    color: #555;\n  }\n  \n  .people-card-editpeople button {\n    background-color: #0073b1;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 10px;\n    font-size: 14px;\n  }\n  \n  .show-more-btn-editpeople {\n    display: block;\n    margin: 20px auto;\n    padding: 8px 16px;\n    background-color: #0073b1;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n  }\n  \n  .page-content-editpeople {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n  }\n  \n  .add-btn-editpeople {\n    background-color: #270388;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 5px 10px;\n    font-size: 14px;\n    cursor: pointer;\n    margin-left: 10px;\n  }\n  \n  .add-btn-editpeople:hover {\n    background-color: #270388;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
